<div class="notifications">
  <div class="header">
    <div class="row1">
      <div>
        <mat-icon> notifications </mat-icon>
      </div>
      <h3>Notifications</h3>
      <div (click)="close()" class="close-btn">
        <mat-icon class="icon">close</mat-icon>
      </div>
    </div>
    <div class="row2">
      <div class="search-bar">
        <app-text-input
          placeholder="Rechercher dans les notifications"
          icon="search"
          iconType="mat-icon"
          (keyup)="search($event)"
        ></app-text-input>
      </div>
    </div>
  </div>
  <div *ngIf="!isLoading; else loading" id="content">
    <overlay-scrollbars class="scrollable-area" [options]="osComponentOptions" *ngIf="!isLoading">
      <div class="notification" *ngFor="let notification of notifications">
        <div class="info">
          <h1>
            <span *ngIf="notification.viewed == false" class="dot"></span>
            <a href="javascript:;" class="button">
              <mat-icon class="mat-icon">
                {{ notification.icon }}
              </mat-icon>
              <div style="padding-top: 4px; padding-left: 7px">
                {{ notification.topic | translate: hospitalNames : true }}
              </div>
            </a>
            <div style="margin-left: 4px">
              {{ notification.title }}
            </div>
          </h1>
          <p>
            {{ notification.body }}
          </p>
          <div class="notification-time" *ngIf="isMultiHospitals">
            <!-- {{ notification.hospital.name }} -->
            {{ notification.hospital.displayName }}
          </div>
          <div class="notification-time">
            {{ notification.createdAt | date: "dd/MM/yyyy à HH 'h' mm" }}
          </div>
        </div>

        <mat-divider style="color: border_color; display: inline-block"></mat-divider>
      </div>
    </overlay-scrollbars>
    <div *ngIf="scrollLoading" class="second-spinner spinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <ng-template #loading>
    <div class="main-spinner spinner">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>
